// FontAwesome icons
import { faFolderTree } from "@fortawesome/pro-duotone-svg-icons";
import ColorChangingIcon from "../../../Common/UI/ColorChangingIcon";

// Kendo React components
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

// Available component types that can be added to tiles
const TILE_COMPONENT_TYPES = {
  treeView: {
    id: "treeView",
    label: "TreeView",
    description: "Add a TreeView to organize and display templates",
    icon: faFolderTree,
  },
};

function TileConfigDialog({ onClose, onAddComponent, tileId }) {
  const handleAddComponent = (componentType) => {
    onAddComponent(tileId, componentType);
    onClose();
  };

  return (
    <Dialog
      title="Add Component to Tile"
      onClose={onClose}
      width={450}
    >
      <div style={{ margin: "20px", textAlign: "left" }}>
        <p style={{ fontSize: 14, marginBottom: "20px", color: "#666" }}>
          Select a component to add to this tile:
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {Object.values(TILE_COMPONENT_TYPES).map((type) => (
            <div
              key={type.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "16px",
                border: "1px solid #e0e0e0",
                borderRadius: "6px",
                backgroundColor: "var(--atlas-bg-primary)",
                cursor: "pointer",
                transition: "background-color 0.2s, border-color 0.2s",
              }}
              onClick={() => handleAddComponent(type.id)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f0f7ff";
                e.currentTarget.style.borderColor = "#4a90d9";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.borderColor = "#e0e0e0";
              }}
            >
              <ColorChangingIcon
                icon={type.icon}
                initialPrimaryColor="#4a90d9"
                initialSecondaryColor="#2e5a87"
                initialSize={24}
                hoverSize={24}
              />
              <div>
                <div style={{ fontWeight: 600, marginBottom: "4px" }}>{type.label}</div>
                <div style={{ fontSize: 12, color: "#666" }}>{type.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <DialogActionsBar>
        <Button
          className="k-button"
          onClick={onClose}
        >
          Cancel
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default TileConfigDialog;
